<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
        <button class="btn btn-outline-success" (click)="onAceptar()" title="Aceptar">Aceptar</button>
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <h4>Nueva Solicitud</h4>
        <label class="col-form-label">Seleccione el tipo de solicitud y pulse el botón de "Aceptar".</label>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedTipos = !isCollapsedTipos" [attr.aria-expanded]="!isCollapsedTipos" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Tipo de Solicitud y Punto de Inspección
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="row">
                            <div class="col-md-6 collapse group-campos" id="collapseTipos" [ngbCollapse]="isCollapsedTipos">

                                    <div *ngIf="!listTipoSolicitud">
                                        <p-progressSpinner class="p-progress-spinner-circle"></p-progressSpinner>
                                    </div>
                                    <div class="ui-g">
                                        <ng-container *ngFor="let item of listTipoSolicitud">
                                            <div class="ui-g-12" (click)="onSelectedTipoSolicitud(item.Codigo)">
                                                <p-radioButton formControlName="tipoSolicitud" (click)="onSelectedTipoSolicitud()" inputStyleClass="form-control" name="tipoSolicitud" [value]="item.Codigo"></p-radioButton>
                                                <label [for]="item.Codigo" class="cursor-hand ml-2">
                                                    <img src="/assets/images/TipoSolicitud/{{item.Id}}.png" class="ps-1" style="width:32px; vertical-align: top;" />
                                                    <span style="vertical-align:middle; margin-left: .2em">{{item.Descripcion}}</span>
                                                </label>
                                            </div>
                                        </ng-container>
                                    </div>
                            </div>

                            <div class="col-md-6 group-campos" [ngbCollapse]="isCollapsedTipos">
                                <div class="form-group col-md-12">
                                    <label class="col-form-label required-field" for="intEstado">Punto de Inspección</label>
                                    <ng-select [items]="listPuntoInspeccion"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPuntoInspeccion"
                                               loadingText="Cargando..."
                                               [loading]="!listPuntoInspeccion"
                                               notFoundText="Punto de Inspección no encontrado"
                                               placeholder="-- Seleccione un Punto de Inspección --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdPuntoInspeccion')">
                                    </ng-select>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPuntoInspeccion','required')">
                                        Punto de Inspección es obligatorio
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div *ngIf="form.value.tipoSolicitud === 'T'">
                    <!--Traslado Seleccionado-->
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedDatosTraslado = !isCollapsedDatosTraslado" [attr.aria-expanded]="!isCollapsedDatosTraslado" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Datos adicionales
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-campos" id="collapseDatosTraslado" [ngbCollapse]="isCollapsedDatosTraslado">
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label required-field" for="inpMedioTransporteTraslado">Medio Transporte Traslado</label>
                                        <ng-select [items]="listMedioTransporte"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   [(ngModel)]="IdMedioTransporteTraslado"
                                                   formControlName="IdMedioTransporteTraslado"
                                                   loadingText="Cargando..."
                                                   [loading]="!listMedioTransporte"
                                                   notFoundText="Medio de Transporte no encontrado"
                                                   placeholder="-- Seleccione un Medio de Transporte --"
                                                   [ngClass]="displayFieldCssNgSelect('IdMedioTransporteTraslado')"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdMedioTransporteTraslado','required')">
                                            Medio de Transporte es obligatorio
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label required-field" for="inpPais">País</label>
                                        <ng-select [items]="listPaisUe"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   [(ngModel)]="IdPaisTraslado"
                                                   formControlName="IdPaisTraslado"
                                                   loadingText="Cargando..."
                                                   [loading]="!listPaisUe"
                                                   notFoundText="País no encontrado"
                                                   placeholder="-- Seleccione un País --"
                                                   [ngClass]="displayFieldCssNgSelect('IdPaisTraslado')"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>


                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisTraslado','required')">
                                            País es obligatorio
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="form.value.tipoSolicitud === 'TD'">
                    <!--Tránsito Directo Seleccionado-->
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedDatosTransitoDirecto = !isCollapsedDatosTransitoDirecto" [attr.aria-expanded]="!isCollapsedDatosTransitoDirecto" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Datos adicionales
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-campos" id="collapsedDatosTransitoDirecto" [ngbCollapse]="isCollapsedDatosTransitoDirecto">
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label required-field" for="inpMedioTransporte">Medio Transporte Tránsito Directo</label>
                                        <ng-select [items]="listMedioTransporte"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   [(ngModel)]="IdMedioTransporteTransitoDirecto"
                                                   formControlName="IdMedioTransporteTransitoDirecto"
                                                   loadingText="Cargando..."
                                                   [loading]="!listMedioTransporte"
                                                   notFoundText="Medio de Transporte no encontrado"
                                                   placeholder="-- Seleccione un Medio de Transporte --"
                                                   [ngClass]="displayFieldCssNgSelect('IdMedioTransporteTransitoDirecto')"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdMedioTransporteTransitoDirecto','required')">
                                            Medio de Transporte es obligatorio
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label required-field" for="inpPais">País destino</label>
                                        <ng-select [items]="listPaisTransitoDirecto"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   [(ngModel)]="IdPaisTransitoDirecto"
                                                   formControlName="IdPaisTransitoDirecto"
                                                   loadingText="Cargando..."
                                                   [loading]="!listPaisTransitoDirecto"
                                                   notFoundText="País no encontrado"
                                                   placeholder="-- Seleccione un País --"
                                                   [ngClass]="displayFieldCssNgSelect('IdPaisTransitoDirecto')"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisTransitoDirecto','required')">
                                            País es obligatorio
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="form.value.tipoSolicitud === 'TB'">
                    <!--Transbordo Seleccionado-->
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedDatosTransbordo = !isCollapsedDatosTransbordo" [attr.aria-expanded]="!isCollapsedDatosTransbordo" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Datos adicionales
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-campos" id="collapsedDatosTransbordo" [ngbCollapse]="isCollapsedDatosTransbordo">
                                <div class="row">
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpMedioTransporte">Medio Transporte Transbordo</label>
                                        <ng-select [items]="listMedioTransporte"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   [(ngModel)]="IdMedioTransporteTransbordo"
                                                   formControlName="IdMedioTransporteTransbordo"
                                                   loadingText="Cargando..."
                                                   [loading]="!listMedioTransporte"
                                                   notFoundText="Medio de Transporte no encontrado"
                                                   placeholder="-- Seleccione un Medio de Transporte --"
                                                   [ngClass]="displayFieldCssNgSelect('IdMedioTransporteTransbordo')"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdMedioTransporteTransbordo','required')">
                                            Medio de Transporte es obligatorio
                                        </div>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpTipoTransbordo">Tipo Transbordo</label>
                                        <ng-select [items]="listTipoTransbordo"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   [(ngModel)]="IdTipoTransbordo"
                                                   formControlName="IdTipoTransbordo"
                                                   loadingText="Cargando..."
                                                   [loading]="!listTipoTransbordo"
                                                   notFoundText="Tipo de Transbordo no encontrado"
                                                   placeholder="-- Seleccione un Tipo de Transbordo --"
                                                   [ngClass]="displayFieldCssNgSelect('IdTipoTransbordo')"
                                                   (change)="onSelectTipoTransbordo()"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTipoTransbordo','required')">
                                            Tipo de Transbordo es obligatorio
                                        </div>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpPais">País destino</label>
                                        <ng-select [items]="listPaisTransbordo"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   [(ngModel)]="IdPaisTransbordo"
                                                   formControlName="IdPaisTransbordo"
                                                   loadingText="Cargando..."
                                                   [loading]="(!listPaisTransbordo && (form.value.IdTipoTransbordo > 0))"
                                                   notFoundText="País no encontrado"
                                                   placeholder="-- Seleccione un País --"
                                                   [ngClass]="displayFieldCssNgSelect('IdPaisTransbordo')"
                                                   (change)="onSelectPaisTransbordo()"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisTransbordo','required')">
                                            País es obligatorio
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="visiblePifTransbordo" class="row">
                                    <div class="form-group col-md-12">
                                        <label class="col-form-label required-field" for="inpPais">PCF Transbordo</label>
                                        <ng-select [items]="listPCFTransbordo"
                                                   bindLabel="PcfTracesLocalidad"
                                                   bindValue="Id"
                                                   [(ngModel)]="IdPuntoInspeccionTransbordo"
                                                   formControlName="IdPuntoInspeccionTransbordo"
                                                   loadingText="Cargando..."
                                                   [loading]="(!listPCFTransbordo && (form.value.IdPaisTransbordo > 0))"
                                                   notFoundText="PCF Transbordo no encontrado"
                                                   placeholder="-- Seleccione un PCF Transbordo --"
                                                   [ngClass]="displayFieldCssNgSelect('IdPuntoInspeccionTransbordo')"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPuntoInspeccionTransbordo','required')">
                                            PCF Transbordo es obligatorio
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div *ngIf="form.value.tipoSolicitud === 'F'">
                    <!--Fines Cientí­ficos Seleccionada-->
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedDatosFines = !isCollapsedDatosFines" [attr.aria-expanded]="!isCollapsedDatosFines" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Datos adicionales
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-campos" id="collapseDatosFines" [ngbCollapse]="isCollapsedDatosFines">
                                <div class="row">
                                    <div class="form-group col-md-3">
                                        <label class="col-form-label required-field" for="inpFecha">Fecha Carta Autorización</label>
                                        <p-calendar formControlName="FechaCartaAutorizacion" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" [ngClass]="displayFieldCssCal('FechaCartaAutorizacion')"></p-calendar>
                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaCartaAutorizacion','required')">
                                            Fecha Carta Autorizacion es obligatorio
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div *ngIf="form.value.tipoSolicitud === 'O'">
                    <!--Organismos Control Biológico Seleccionada-->
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedOcb = !isCollapsedOcb" [attr.aria-expanded]="!isCollapsedOcb" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Datos adicionales
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-campos" id="collapsedOcb" [ngbCollapse]="isCollapsedOcb">
                                <div class="row">
                                    <div class="form-group col-md-3">
                                        <label class="col-form-label required-field" for="inpFecha">Fecha Carta Autorización</label>
                                        <p-calendar formControlName="FechaCartaAutorizacion" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" [ngClass]="displayFieldCssCal('FechaCartaAutorizacion')"></p-calendar>
                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaCartaAutorizacion','required')">
                                            Fecha Carta Autorizacion es obligatorio
                                        </div>

                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <!--Normal o Pasajeros Seleccionada o Productos Fitosanitarios -->
                <div class="card card-accent-success animated fadeIn" *ngIf="(form.value.tipoSolicitud === 'N' || form.value.tipoSolicitud === 'P' || form.value.tipoSolicitud === 'PF') && !esGrabador">
                    <a class="card-header-a" (click)="isCollapsedPrevia = !isCollapsedPrevia" [attr.aria-expanded]="!isCollapsedPrevia" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Otros Datos
                        </div>
                    </a>

                    <div class="card-body-detalle">
                        <div class="collapse group-campos" id="collapsePrevia" [ngbCollapse]="isCollapsedPrevia">
                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="">Previa</label>
                                    <p-toggleButton class="form-control-togglebutton" formControlName="esPrevia" (onChange)="onSelectedPrevia()" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                    offIcon="pi pi-times"></p-toggleButton>
                                </div>
                                <!--Sólo para normales-->
                                <div *ngIf="form.value.tipoSolicitud === 'N'" class="form-group col-md-3">
                                    <label class="col-form-label" for="">Re-Importación</label>
                                    <p-toggleButton class="form-control-togglebutton" formControlName="esReImportacion" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                    offIcon="pi pi-times"></p-toggleButton>
                                </div>

                                <div *ngIf="form.value.tipoSolicitud === 'N' && visibleFinalizacionTraslado" class="form-group col-md-3">
                                    <label class="col-form-label" for="">Finaliza Traslado</label>
                                    <p-toggleButton class="form-control-togglebutton" formControlName="finalizaTraslado" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                    offIcon="pi pi-times" (onChange)="CheckFinalizaTraslado($event)"></p-toggleButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Sólo para normales que van a finalizar un Traslado-->
                <div *ngIf="(form.value.tipoSolicitud === 'N' && form.value.finalizaTraslado === true) && !esGrabador" class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedDatosFinTraslado = !isCollapsedDatosFinTraslado" [attr.aria-expanded]="!isCollapsedDatosFinTraslado" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos de finalización del Traslado
                        </div>
                    </a>

                    <div class="card-body-detalle">
                        <div class="collapse group-campos" id="collapseDatosFinTraslado" [ngbCollapse]="isCollapsedDatosFinTraslado">
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label class="col-form-label required-field" for="inpCHEDPP">CHEDPP TRACES Traslado</label>
                                    <input formControlName="CHEDPP" name="CHEDPP" class="form-control" [ngClass]="displayFieldCss('CHEDPP')" maxlength="40" type="text" (ngModelChange)="CheckCHEDPP($event)" value="">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('CHEDPP','required')">
                                        El CHEDPP es obligatorio
                                    </div>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="">Código de la solicitud de Traslado</label>
                                    <div class="input-group">
                                        <input [readonly]="!CHEDPPES" formControlName="CodigoSolicitudTraslado" name="CodigoSolicitudTraslado" class="form-control" id="inpNombre" type="text">
                                        <span class="input-group-btn">
                                            &nbsp;<button [disabled]="!CHEDPPES || !form.value.CodigoSolicitudTraslado" name="btnShowSearchCodigoSolicitudTraslado" class="btn btn-list btn-secondary" type="button" title="Buscador de solicitudes de Traslado a partir del código" (click)="onSearchCodigoSolicitudTraslado(form.value.CodigoSolicitudTraslado)"><i class="fa fa-search"></i></button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-12">
                                    <div *ngIf="mensajeSolicitudTrasladoValida !== '' && mensajeSolicitudTrasladoNOValida === ''" class="empty-grid-green-text" stye>
                                        {{mensajeSolicitudTrasladoValida}}
                                    </div>
                                    <div *ngIf="mensajeSolicitudTrasladoValida === '' && mensajeSolicitudTrasladoNOValida !== ''" class="empty-grid" stye>
                                        {{mensajeSolicitudTrasladoNOValida}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Canarias-->
                <div class="card card-accent-success animated fadeIn" *ngIf="form.value.tipoSolicitud === 'C'">
                    <a class="card-header-a" (click)="isCollapsedTipoCanarias = !isCollapsedTipoCanarias" [attr.aria-expanded]="!isCollapsedTipoCanarias" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Tipos Solicitud Canarias
                        </div>
                    </a>

                    <div class="card-body-detalle">
                        <div class="collapse group-campos" id="collapseTipoCanarias" [ngbCollapse]="isCollapsedTipoCanarias">
                            <div class="row">
                                <div class="form-group col-md-12">

                                    <div class="ui-g">
                                        <div class="ui-g-12">
                                            <p-radioButton formControlName="EsConCF" (click)="onSelectedEsConCF()" inputStyleClass="form-control" name="EsConCF" value="0" label="CF sin PIN o sin CF"></p-radioButton>
                                        </div>
                                        <div class="ui-g-12">
                                            <p-radioButton formControlName="EsConCF" (click)="onSelectedEsConCF()" inputStyleClass="form-control" name="EsConCF" value="1" label="CF con PIN"></p-radioButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Canarias con CF-->
                <div class="card card-accent-success animated fadeIn" *ngIf="form.value.tipoSolicitud === 'C' && form.value.EsConCF === '1'">
                    <a class="card-header-a" (click)="isCollapsedDatosCertificadoExp = !isCollapsedDatosCertificadoExp" [attr.aria-expanded]="!isCollapsedDatosCertificadoExp" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos Certificado Exportación
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="collapse group-campos" id="collapseDatosCertificadoExp" [ngbCollapse]="isCollapsedDatosCertificadoExp">
                            <div class="row">
                                <div class="form-group col-md-8">
                                    <label class="col-form-label required-field" for="inpDescripcion">Nº Certificado</label>
                                    <input formControlName="NumCertificado" maxlength="9" name="" title="" class="form-control" [ngClass]="displayFieldCss('NumCertificado')" id="" type="text" value="">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('NumCertificado','required')">
                                        Nº Certificado es obligatorio
                                    </div>
                                </div>
                                <div class="form-group col-md-4">
                                    <label class="col-form-label required-field" for="inpDescripcion">PIN</label>
                                    <input formControlName="Pin" maxlength="6" name="" title="" class="form-control" [ngClass]="displayFieldCss('Pin')" id="" type="text" value="">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Pin','required')">
                                        PIN es obligatorio
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Canarias, Normal o Prductos Fitosanitarios -->
                <div *ngIf="showPreDUA">
                    <div *ngIf="!esGrabador && !form.value.esPrevia" class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedDatosPredua = !isCollapsedDatosPredua" [attr.aria-expanded]="!isCollapsedDatosPredua" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Datos Pre-DUA
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-campos" id="collapseDatosPredua" [ngbCollapse]="isCollapsedDatosPredua">
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="inpHabilitado">Pre-DUA</label>
                                        <p-toggleButton class="form-control-togglebutton" (onChange)="onSelectedPreDua()" formControlName="esPredua" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                        offIcon="pi pi-times"></p-toggleButton>
                                    </div>
                                    <div class="form-group col-md-8">
                                        <label class="col-form-label" [ngClass]="{ 'required-field': isFieldInvalidNoSubmit('Mrn','required') }" for="inpMrn">MRN</label>
                                        <input formControlName="Mrn" name="Mrn" title="" class="form-control" [ngClass]="displayFieldCss('Mrn')"
                                               id="" maxlength="21" type="text" value="">

                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('Mrn','required')">
                                            Mrn es obligatorio
                                        </div>
                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('Mrn','minlength')">
                                            Mrn debe tener 18 caracteres
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card-body-detalle">
                    <div class="form-group" *ngIf="!isNifFijo">
                        <label class="col-form-label" for="inpHabilitado">Importador No Nacional</label>
                        <p-toggleButton class="form-control-togglebutton" (onChange)="onSelectedNifExtranjero()" formControlName="esNifExtranjero" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                        offIcon="pi pi-times"></p-toggleButton>
                    </div>
                </div>

            </div>
        </div>
    </div>

</form>
